<template>
    <v-container>
      <div>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" justify="center">
              <p class="header-title"> {{$t('menu.category')}} </p>
          </v-col>

          <v-col cols="12" sm="6" justify="center" class="pr-5">
          </v-col>
        </v-row>
      </div>
      <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="email" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
          <template v-slot:top>
            <v-toolbar flat color="white" class="pt-2">
              <v-row justify="start">
                <v-col cols="12" sm="1">
                </v-col>

                <v-col cols="12" sm="2">
                </v-col>
                
                <v-col cols="12" sm="2">
                </v-col>

                <v-col cols="12" sm="7">
                  <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined dense></v-text-field>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

          <template v-slot:no-data>
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('permission_management.name'), value: 'title' },
        { text: i18n.t('permission_management.description'), sortable: false, value: 'description' },
        { text: i18n.t('permission_management.value'), sortable: false, value: 'type' },
        // { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
          v => (v && v.length > 5) || i18n.t('validate.string_invalid')
      ]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('permission_management.add') : i18n.t('permission_management.edit')
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    async mounted() {
      await this.getData()
    },

    methods: {
      initialize () {
    //     this.selectType = this.types[1];
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        if (this.editedIndex > -1) {
          const self = this;
          const requestBody = self.editedItem;
          requestBody.type = this.selectType.value;

          try {
              const response = await this.$http.put(process.env.VUE_APP_CONTEXT_URL + self.editedItem._id, requestBody);
              if (response.data && response.data.success) {
                  Object.assign(this.desserts[this.editedIndex], this.editedItem);
                  self.editedItem = {};
              }
            } catch (e) {
                console.log(e.stack);
            }
        } else {
            const self = this;
            const requestBody = self.editedItem;
            requestBody.type = this.selectType.value;
            try {
                const response =  await this.$http.post(process.env.VUE_APP_CONTEXT_URL, requestBody);
                if(response.data && response.data.success) {
                    self.editedItem._id = response.data.data.id;
                    
                    this.desserts.push(self.editedItem);
                    self.editedItem.index = this.desserts.length;
                    self.editedItem = {};

                    this.$fire({
                        title: i18n.t('common.success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                            
                    });

                }
            } catch(e) {
                console.log(e.stack);
            }
        }
        this.close()
      },

      async getData() {
        try {
            const response =  await this.$http.get('/job/categories/0');
            if(response.data && response.data.success) {
                // console.log(response.data);
                
                const contextArr = response.data.data;
                contextArr.forEach((item, index) =>item.index = index + 1);

                this.desserts = contextArr;
            }
        } catch(e) {
            //TODO add alert / flash service to Vue => Like Toast in Android

            //Only print stack trace if development
            console.log(e.stack);
            // dùng vue alert //alert(e.message);
        }
      }
    },
  }
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>